import { useState } from "react";
import { Box } from "../../../../../../components/box";
import InformationLayout from "../../../../components/layout/InformationLayout";
import FormButton from "./button";
import FormContent from "./content";

const EprInformation = () => {
  /**
   * Form states
   */
  const [assignList, setAssignList] = useState<any>([]);
  const [iTHeadSelected, setITHeadSelected] = useState(null as any);
  const [iTHeadName, setITHeadName] = useState(null as any);

  return (
    <InformationLayout>
      <Box title="Thông tin cấp/thay đổi/xoá code Amadeus" className="full-height box__detail-container">
        <FormContent
          setAssignList={setAssignList}
          setITHeadName={setITHeadName}
          setITHeadSelected={setITHeadSelected}
        />

        <FormButton
          assignList={assignList}
          iTHeadName={iTHeadName}
          iTHeadSelected={iTHeadSelected}
        />
      </Box>
    </InformationLayout>
  );
};

export default EprInformation;
